<template>
  <v-dialog v-model="dialog" max-width="500px">
    <template v-slot:activator="{ props }">
      <v-btn color="primary" dark class="mb-2" v-bind="props">
        {{ $t('user.addUser') }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ $t('user.addNewUser') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form @submit.prevent="addUser" ref="form">
          <v-text-field
            v-model="username"
            :label="$t('user.username')"
            required
          ></v-text-field>
          <v-text-field
            v-model="password"
            :label="$t('user.password')"
            type="password"
            required
            :rules="[passwordRules.required, passwordRules.min, passwordRules.hasNumber, passwordRules.hasUppercase]"
          ></v-text-field>
          <v-text-field
            v-model="confirmPassword"
            :label="$t('user.confirmPassword')"
            type="password"
            required
            :rules="[passwordRules.required, passwordMatch]"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">{{ $t('user.cancel') }}</v-btn>
        <v-btn color="blue darken-1" text @click="addUser" :disabled="!isFormValid">{{ $t('user.add') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import axios from 'axios'

const emit = defineEmits(['user-added'])

const dialog = ref(false)
const username = ref('')
const password = ref('')
const confirmPassword = ref('')
const form = ref(null)

const passwordRules = {
  required: value => !!value || 'Password is required',
  min: v => v.length >= 8 || 'Password must be at least 8 characters',
  hasNumber: v => /\d/.test(v) || 'Password must contain a number',
  hasUppercase: v => /[A-Z]/.test(v) || 'Password must contain an uppercase letter'
}

const passwordMatch = () => password.value === confirmPassword.value || 'Passwords do not match'

const isFormValid = computed(() => {
  return username.value && password.value && confirmPassword.value &&
         password.value === confirmPassword.value &&
         password.value.length >= 8 &&
         /\d/.test(password.value) &&
      /[A-Z]/.test(password.value)
})

async function addUser() {
  if (!isFormValid.value) return

  try {
    await axios.post('/api/users', {
      username: username.value,
      password: password.value
    })
    emit('user-added')
    dialog.value = false
    username.value = ''
    password.value = ''
    confirmPassword.value = ''
  } catch (error) {
    console.error('Error adding user:', error)
  }
}
</script>
